module.exports = __webpack_public_path__ + "img/w14b.91418bab.jpg";